<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header class="flex-container-space-between">
    <mat-panel-title>
      {{ 'generalCollateralHistoryExpandable.history' | transloco }}
    </mat-panel-title>
    <mat-panel-description class="flex-container-right-align">
      <mat-icon class="margin-right-15">history</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  @for (node of history; track node; let i = $index) {
    <div>
      @if (i === 0 || (node.collateralValue && node.registrationNumber)) {
        <div class="margin-bottom-15">
          <div class="light-bold margin-bottom-5">{{ i === 0 ? 'Original' : 'Replaced by registration number ' + node.registrationNumber }}:</div>
          @if (node.collateralValue) {
            <span class="preserve-line-breaks">{{ node.collateralValue }}</span>
          } @else {
            <span class="text-faded">{{ 'generalCollateralHistoryExpandable.noCollateralFound' | transloco }}</span>
          }
        </div>
      }
      @if (i > 0 && node.collateralToAdd && node.registrationNumber) {
        <div class="margin-bottom-15">
          <div class="light-bold margin-bottom-5">{{ 'generalCollateral.addedByRegistrationNumber' | transloco: { number: node.registrationNumber } }}</div>
          <span class="preserve-line-breaks">{{ node.collateralToAdd }}</span>
        </div>
      }
      @if (i > 0 && node.collateralToRemove && node.registrationNumber) {
        <div class="margin-bottom-15">
          <div class="light-bold margin-bottom-5">{{ 'generalCollateral.removedByRegistrationNumber' | transloco: { number: node.registrationNumber } }}</div>
          <span class="preserve-line-breaks">{{ node.collateralToRemove }}</span>
        </div>
      }
    </div>
  }
</mat-expansion-panel>